import * as types from './task-modals.types';
import * as constants from './task-modals.constants';

export const storeTaskModalStatus = (key: types.ITaskModalKey): types.IStoreTaskModalStatus => ({
  type: constants.STORE_TASK_MODAL_STATUS,
  payload: key,
});
export const clearTaskModalStatus = (key: types.ITaskModalKey): types.IClearTaskModalStatus => ({
  type: constants.CLEAR_TASK_MODAL_STATUS,
  payload: key,
});
export const clearTaskModalStatuses = (): types.IClearTaskModalStatuses => ({
  type: constants.CLEAR_TASK_MODAL_STATUSES,
});
